import React, { useContext, useEffect, useState } from "react";
import { usePaypal } from "../services/paypal";
import { getTotalPriceStr, isDev, isDeveloperDev } from "../helpers";
import { UserContext, OrderContext } from "../context";
import { updateDataWithId, useOrder } from "../services/firestore";
import { useParams } from "react-router-dom";
import { Typography, Grid, CircularProgress } from "@material-ui/core";
import PrettyJSON from "../components/PrettyJSON";

export default () => {
  const { orderID } = useParams();
  const { orderInfo, orderLoaded } = useOrder(orderID);
  const { order, contactInfo, paid } = orderInfo;
  const isFreeDeliver = contactInfo.isFreeDistance;
  const orderTotal = orderLoaded ? Number(getTotalPriceStr(order)) : 0;
  const deliverCost = isFreeDeliver ? 0 : 5;
  const totalPrice = orderLoaded ? orderTotal + deliverCost : 0;
  console.log(totalPrice);
  const paypalFee = orderLoaded ? 0.35 + (2.49 / 100) * totalPrice : 0;
  const { user } = useContext(UserContext);
  const [PaypalBtn, payDetail, payError] = usePaypal(
    (totalPrice + paypalFee).toFixed(2),
    `${user.name}: ${order.map(({ id }) => id).join(", ")}`
  );

  useEffect(() => {
    if (payDetail.paid) {
      updateDataWithId({
        collection: isDeveloperDev ? "devOrders" : "orders",
        id: orderID,
        content: {
          paid: true,
          paidTotal: payDetail.detail.reduce((arr, cur) => {
            arr += Number(cur.amount.value);
            return arr;
          }, 0),
        },
      });
    }
  }, [payDetail]);

  const PayDiv = (
    <Grid>
      {!orderLoaded && <CircularProgress />}
      <Typography variant="h5">
        Sie dürfen <b>online</b> oder <b>vor Ort</b> bezahlen. Paypal Gebühr
        beträgt {paypalFee.toFixed(2)}€.
      </Typography>
      {orderLoaded && PaypalBtn}
    </Grid>
  );

  const PaidFinish = (
    <Typography variant="h5">Bezahlen erfolgreich!</Typography>
  );

  return (
    <>
      {orderTotal > 0 && (paid ? PaidFinish : PayDiv)}
      {orderTotal > 0 && payError && <h1>Error. Bitte kontaktieren uns!</h1>}
      {isDev && payError && (
        <PrettyJSON json={{ payError }} keyLabel="paypalPay" />
      )}
      {isDev && (
        <PrettyJSON json={{ order, user, payDetail }} keyLabel="paypalPay" />
      )}
    </>
  );
};
